import React from "react";
import { _t } from "src/utils";
import "./alfred-kyc-fallback.scss";

/**
 * Post-submit "in review" state for the KYC update-required flow. Shares
 * the visual language of AlfredIneligibleBlocker but uses a neutral
 * info treatment instead of the warning icon.
 */
const AlfredKycFallbackReview: React.FC = () => {
  return (
    <div className="alfred-blocker alfred-kyc-fallback-review">
      <div className="alfred-blocker__icon alfred-kyc-fallback-review__icon">✓</div>
      <h2 className="alfred-blocker__title">
        {_t("ALFRED.KYC_FALLBACK.SUBMITTED_TITLE", { defaultValue: "Submitted for review" })}
      </h2>
      <p className="alfred-blocker__message">
        {_t("ALFRED.KYC_FALLBACK.SUBMITTED_MESSAGE", {
          defaultValue:
            "Thanks — your details are being reviewed. This page will update automatically once the review completes.",
        })}
      </p>
    </div>
  );
};

export default AlfredKycFallbackReview;
